import React from 'react';
import { DEFAULT_PROJECT_FILTER, COMPLETED } from '../../config/projectSettings';
import { ProjectContext } from './ProjectContext';
import ProjectList from './ProjectList';

const CompletedFilter = { ...DEFAULT_PROJECT_FILTER, status: COMPLETED };

const CompletedProjects = () => (
  <ProjectContext.Provider value={{ returnPath: '/projects/completed' }}>
    <ProjectList title="Completed projects" initialFilter={CompletedFilter} />
  </ProjectContext.Provider>
);

export default CompletedProjects;



// WEBPACK FOOTER //
// ./src/components/projects/Completed.js